import React, { Component, type JSX, type ReactNode } from 'react';

import {
  commandMenuIndexForShortcutSettings,
  searchIndexForShortcutSettings
} from '../components/settings/manage-appearance/keyboard-shortcuts-settings';
import { LOCAL_STORAGE_USER_PREFERENCES } from '../constants/general';
import {
  getObjectFromLocalStorage,
  safeLocalStorage
} from '../helpers/local-storage.helper';

type UserContextProps = {
  children: ReactNode[] | ReactNode;
};

type KeyboardShortcutsSettings = 'commandMenuShortcut' | 'searchMenuShortcut';

type UserPreferences = {
  [key in KeyboardShortcutsSettings]?: number;
} & { minimizeDownloadManager?: boolean };
export type UserContextState = {
  preferences: UserPreferences;
  setPreferences: (preference: UserPreferences, reload?: boolean) => void;
  getDefaultsFromLocalStorage: () => UserPreferences;
};

const initialState: UserContextState = {
  preferences: {
    commandMenuShortcut: commandMenuIndexForShortcutSettings,
    searchMenuShortcut: searchIndexForShortcutSettings
  },
  setPreferences: () => false,
  getDefaultsFromLocalStorage: () => undefined
};

export const UserContext = React.createContext(initialState);

export class UserProvider extends Component<
  UserContextProps,
  UserContextState
> {
  readonly state: UserContextState = {
    ...initialState,

    setPreferences: (preference, refresh = false) => {
      const updatedPreferences = { ...this.state.preferences, ...preference };
      this.updateLocalStorage(updatedPreferences);

      this.setState(() => ({
        preferences: updatedPreferences
      }));

      if (refresh) {
        window.location.reload();
      }
    },
    getDefaultsFromLocalStorage: () => {
      return getObjectFromLocalStorage<UserPreferences>(
        LOCAL_STORAGE_USER_PREFERENCES,
        {}
      );
    }
  };

  componentDidMount(): void {
    const userPreferences = this.state.getDefaultsFromLocalStorage();

    this.setState(() => ({
      preferences: {
        commandMenuShortcut: initialState.preferences.commandMenuShortcut,
        searchMenuShortcut: initialState.preferences.searchMenuShortcut,

        ...userPreferences
      }
    }));
  }

  updateLocalStorage(newState: UserContextState['preferences']): void {
    safeLocalStorage.setItem(
      LOCAL_STORAGE_USER_PREFERENCES,
      JSON.stringify(newState)
    );
  }

  render(): JSX.Element {
    return (
      <UserContext.Provider value={this.state}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}
